import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-set-clear-all"
export default class extends Controller {
  static targets = [ "checkbox" ]

  checkAsMe(event) {
    event.preventDefault()
    if (event.target.checked) {
      this.checkAllCheckboxes()
    } else {
      this.clearAllCheckboxes()
    }
  }

  checkAll(event) {
    event.preventDefault()
    this.checkAllCheckboxes()
  }

  clearAll(event) {
    event.preventDefault()
    this.clearAllCheckboxes()
  }

  checkAllCheckboxes() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  clearAllCheckboxes() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }
}
